import 'slick-carousel';

let resourceStrings = [];

if ($('.onekey-landing').length) {
  const culture =
    $('.javascriptCulture').length > 0 ? $('.javascriptCulture input').val() : 'en-gb';

  (function getLocalisedStrings() {
    return $.ajax({
      type: 'GET',
      url: '/api/Localisation/LocaliseStrings',
      data: {
        keys: 'Next,StartOver',
        culture,
      },
      complete(data) {
        resourceStrings = data.responseJSON;
        $('.localise-next').text(resourceStrings.Next);
      },
    });
  })();
}

// ONE KEY hero carousel
$('.js-carousel-m18').slick({
  dots: false,
  infinite: true,
  fade: false,
  arrows: false,
  slidesToShow: 5,
  responsive: [
    {
      breakpoint: 950,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 720,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerMode: true,
      },
    },
  ],
});

// Redlithium-ion Image carousel
$('.js-carousel-m18-red').slick({
  dots: false,
  infinite: true,
  fade: false,
  arrows: false,
  slidesToShow: 6,
  responsive: [
    {
      breakpoint: 950,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 720,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerMode: true,
      },
    },
  ],
});

// ONE KEY hero carousel
$('.js-carousel').slick({
  adaptiveHeight: true,
  dots: true,
  infinite: true,
  speed: 500,
  fade: false,
  cssEase: 'ease',
  infinate: false,
  asNavFor: '.js-slider-nav',
  // arrows: false,
  appendArrows: $('.js-carousel'),
  prevArrow:
    '<button type="button" aria-label="Previous" class="hero__pagination-item carousel-prev"><img src="/SiteFiles/img/features-carousel/arrow-white.png" /><span class="visuallyhidden">Previous</span></button>',
  nextArrow: '<div class="nxt-btn-slide"><span class="localise-next">Next</span> ></div>',
});

$('.js-carousel-tracking').slick({
  adaptiveHeight: true,
  dots: true,
  infinite: true,
  speed: 500,
  fade: false,
  cssEase: 'ease',
  infinate: false,
  appendArrows: $('.js-carousel-tracking'),
  prevArrow:
    '<button type="button" aria-label="Previous" class="hero__pagination-item carousel-prev"><img src="/SiteFiles/img/features-carousel/arrow-white.png" /><span class="visuallyhidden">Previous</span></button>',
  nextArrow: '<div class="nxt-btn-slide"><span class="localise-next">Next</span> ></div>',
});

$('.js-slider-nav').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  asNavFor: '.js-carousel',
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinate: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
      },
    },
  ],
});

$('.js-carousel-reports').slick({
  adaptiveHeight: true,
  dots: true,
  infinite: true,
  speed: 500,
  fade: false,
  cssEase: 'ease',
  asNavFor: '.js-slider-nav-reports',
  // arrows: false,
  appendArrows: $('.js-carousel-reports'),
  prevArrow:
    '<button type="button" aria-label="Previous" class="hero__pagination-item carousel-prev"><img src="/SiteFiles/img/features-carousel/arrow-white.png" /><span class="visuallyhidden">Previous</span></button>',
  nextArrow: '<div class="nxt-btn-slide"><span class="localise-next">Next</span> ></div>',
});
$('.js-slider-nav-reports').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.js-carousel-reports',
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinate: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
      },
    },
  ],
});

$('.js-carousel-content').slick({
  adaptiveHeight: true,
  dots: false,
  infinite: false,
  speed: 500,
  fade: true,
  cssEase: 'ease',
  arrows: true,
  prevArrow: '<span class="visuallyhidden">Previous</span>',
  nextArrow: '<div class="nxt-btn"><span class="localise-next">Next</span> ></div>',
});

// Onekey support, to be enabled at a later date
$('.js-support-carousel').slick({
  adaptiveHeight: false,
  dots: false,
  infinite: true,
  speed: 500,
  fade: false,
  cssEase: 'ease',
  infinate: false,
  asNavFor: '.js-slider-nav',
  draggable: false,
  appendArrows: $('.js-support-carousel'),
  prevArrow:
    '<button type="button" aria-label="Previous" class="hero__pagination-item carousel-prev"><img src="/SiteFiles/img/features-carousel/arrow-white.png" /><span class="visuallyhidden">Previous</span></button>',
  nextArrow: '<div class="nxt-btn-slide"><span class="localise-next">Next</span> ></div>',
});
$('.js-support-tabs').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.js-support-carousel',
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinate: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 3,
      },
    },
  ],
});

// ONE KEY hero carousel functions

$('.js-carousel').on('beforeChange swipe', (event, slick, currentSlide, nextSlide) => {
  const chooseChild = nextSlide;
  $('.js-slider-nav .onekey-landing__features-carousel-navigation--button').removeClass(
    'slick-current',
  );
  $(
    `.js-slider-nav .onekey-landing__features-carousel-navigation--button:eq(${chooseChild})`,
  ).addClass('slick-current');
});

$('.js-carousel-content').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  const slider = $(this);
  const slideCount = $('.js-carousel-content .slick-slide').length;
  const nextSlideIndex = nextSlide + 1;
  const button = slider.find('.nxt-btn');

  if (nextSlideIndex === slideCount) {
    button.text(`< ${resourceStrings.StartOver}`);
  } else {
    button.text(`${resourceStrings.Next} >`);
  }

  button.unbind('click').click(() => {
    if (nextSlideIndex === slideCount) {
      slider.slick('slickGoTo', 0);
    } else {
      slider.slick('slickGoTo', nextSlideIndex);
    }
  });
});

$('.js-carousel-reports').on('beforeChange swipe', (event, slick, currentSlide, nextSlide) => {
  const chooseChild = nextSlide;
  $(
    '.onekey-landing__reports-carousel-navigation .onekey-landing__features-carousel-navigation--button',
  ).removeClass('slick-current');
  $(
    `.onekey-landing__reports-carousel-navigation .onekey-landing__features-carousel-navigation--button:eq(${chooseChild})`,
  ).addClass('slick-current');
});

$('.js-carousel-recommended').slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  adaptiveHeight: false,
  variableWidth: false,
  infinite: true,
  speed: 700,
  fade: false,
  cssEase: 'ease',
  arrows: true,
  prevArrow: '<div class="nav-button prev"><i class="fa fa-caret-left"></div>',
  nextArrow: '<div class="nav-button next"><i class="fa fa-caret-right"></div>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
});

$('.js-carousel-heated-gear').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  adaptiveHeight: false,
  variableWidth: false,
  infinite: true,
  speed: 700,
  fade: false,
  cssEase: 'ease',
  arrows: true,
  prevArrow: '<div class="nav-button prev"><i class="fa fa-caret-left"></div>',
  nextArrow: '<div class="nav-button next"><i class="fa fa-caret-right"></div>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

// Used to fix the slider no resetting to 0 when the screen is resized, this is an issue when going
// from a small screen size to a large screen size
if ($('.js-carousel-heated-gear').length) {
  $(window).resize(() => {
    $('.js-carousel-heated-gear').slick('slickGoTo', 0);
  });
}
